import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderSlot as _renderSlot, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, mergeProps as _mergeProps, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import type { HTMLAttributes } from 'vue';
    import { reactiveOmit } from '@vueuse/core';
    import { CollapsibleContent, type CollapsibleContentProps } from 'reka-ui';
    import { cn } from '@/lib/utils';

    
export default /*@__PURE__*/_defineComponent({
  __name: 'CollapsibleContent',
  props: {
    forceMount: { type: Boolean },
    asChild: { type: Boolean },
    as: { type: [String, Object, Function] },
    class: {}
  },
  setup(__props: any) {

    const props = __props;

    const delegatedProps = reactiveOmit(props, 'class');

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(CollapsibleContent), _mergeProps({ "data-slot": "collapsible-content" }, props, { class: "data-[state=open]:animate-slideDown data-[state=closed]:animate-slideUp overflow-hidden" }), {
    default: _withCtx(() => [
      _createElementVNode("div", {
        class: _normalizeClass(_unref(cn)('pt-0', props.class))
      }, [
        _renderSlot(_ctx.$slots, "default")
      ], 2)
    ]),
    _: 3
  }, 16))
}
}

})